module.exports = __webpack_public_path__ + "assets/images/rbyearend-11.jpg?v=b862c10b";